import styled from 'styled-components';
import { Select } from '@material-ui/core';

import { Color } from '../../../constants/Color';
import appTheme from '../../../themes/Theme';

export const StyledSelect = styled(Select)`
  .MuiSelect-select.MuiSelect-select {
    color: ${appTheme.textColor};
  }

  &.MuiInput-underline:before {
    border-color: ${Color.PuertoRico};
  }

  &.MuiInput-underline:after {
    border-color: ${Color.PuertoRico};
  }

  &.MuiInput-underline:hover:not(.Mui-disabled):before {
    border-color: ${Color.PuertoRico};
  }

  & .MuiSelect-icon {
    color: ${appTheme.textColor};
  }
`;

